<div class="content-pane">
  <h2>Edit Project Access</h2>
  <div class="meta-subheader lifted expanded-margin-bottom">
    Project: <a [routerLink]="pdeRoutes.projectView(project().id)">{{ project().name }}</a>
  </div>
  <div>
      @if (project()?.flags._can_manage_permission) {
        <app-permissions-table
          [rows]="permissionRows"
          [context]="permissionsContext"
          (save)="onSavePermission($event)"
          (delete)="onDeletePermission($event)"
        ></app-permissions-table>
      }
  </div>
  <div class="content-subsection half-margin-top half-margin-bottom">
    <h3 class="meta-subheader half-margin-bottom">Public Data Commons Project Details Visibility</h3>
    <div>
      <form [formGroup]="visibilityForm">
        <mat-radio-group class="flex flex-col" formControlName="visibility">
          <mat-radio-button value="team"> Not visible in the Public Data Commons </mat-radio-button>

          <mat-radio-button value="public"> Visible in the Public Data Commons </mat-radio-button>
        </mat-radio-group>
      </form>
    </div>
  </div>

  <div class="form-actions">
    <a matButton="filled" class="cancelbtn" [routerLink]="pdeRoutes.projectView(project()?.id)">
      <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
      Back to Project
    </a>
  </div>

  @if (project()?.flags._can_delete_meta) {
    <div class="content-subsection" appSubsectionScroll data-subsection="delete">
      <h3>Delete Project</h3>

      <button matButton="filled" type="button" class="danger subsection-action" (click)="deleteProject()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon>
        Delete Project
      </button>
    </div>
  }
</div>
